import api from 'api';

export const loadActivityTypes = api(
  'GET /api/promocodes/filters/activity-types'
);
export const loadStatuses = api('GET /api/promocodes/filters/statuses');
export const loadApplications = api('GET /api/promocodes/filters/applications');
export const loadPlatforms = api('GET /api/promocodes/filters/platforms');
export const loadRewards = api('GET /api/promocodes/filters/rewards');
export const loadRequestedBy = api('GET /api/promocodes/filters/requested-by');
export const loadReAttrs = api('GET /api/promocodes/filters/reattribution');
export const loadTypes = api('GET /api/promocodes/filters/promocodetypes');
export const loadRewardTypes = api('GET /api/promocodes/filters/rewardTypes');
